import product1 from "../../images/product-1.jpg";
import product2 from "../../images/product-2.jpg";
import product3 from "../../images/product-3.jpg";
import sweet1 from "../../images/sweet1.jpg";
import sweet2 from "../../images/sweet2.jpg";
import sweet3 from "../../images/sweet3.jpg";
import sweet4 from "../../images/sweet-1.jpg";
import sweet5 from "../../images/sweet-2.jpg";
import sweet6 from "../../images/sweet-3.jpg";
import featureSweet from "../../images/sweet-4.jpg";
import featurePizza from "../../images/featured3.jpg";

const initialState = {
  products: [
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 4,
      discountPrice: 19.99 - (4 / 100) * 19.99,
      quantity: 10,
      id: 1,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 7,
      discountPrice: 16.99 - (7 / 100) * 16.99,
      quantity: 10,
      id: 2,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 14.99 - (10 / 100) * 14.99,
      quantity: 10,
      id: 3,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 4,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 5,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 6,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 7,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 8,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 9,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 10,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 12,
      discountPrice: 16.99 - (12 / 100) * 16.99,
      quantity: 10,
      id: 11,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 13,
      discountPrice: 14.99 - (13 / 100) * 14.99,
      quantity: 10,
      id: 12,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 14,
      discountPrice: 9.99 - (14 / 100) * 9.99,
      quantity: 10,
      id: 13,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 12.99 - (20 / 100) * 12.99,
      quantity: 10,
      id: 14,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 15,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 16,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 21,
      discountPrice: 12.99 - (21 / 100) * 12.99,
      quantity: 10,
      id: 17,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 18,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 19,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 16.99 - (22 / 100) * 16.99,
      quantity: 10,
      id: 20,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 14.99 - (22 / 100) * 14.99,
      quantity: 10,
      id: 21,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 23,
      discountPrice: 9.99 - (23 / 100) * 9.99,
      quantity: 10,
      id: 22,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 23,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 24,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 25,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 26,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 27,
    },
    {
      img: featurePizza,
      alt: "Pizza",
      name: "Truffle alfredo sauce",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 15.99,
      button: "Add to Cart",
      discount: 24,
      discountPrice: 19.99 - (24 / 100) * 19.99,
      quantity: 10,
      id: 28,
    },
    {
      img: featureSweet,
      alt: "cheese",
      name: "chesse cupcakes",
      desc: "Belgian chocolate cream cheese cupcakes covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 29,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 4,
      discountPrice: 19.99 - (4 / 100) * 19.99,
      quantity: 10,
      id: 30,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 7,
      discountPrice: 16.99 - (7 / 100) * 16.99,
      quantity: 10,
      id: 31,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 14.99 - (10 / 100) * 14.99,
      quantity: 10,
      id: 32,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 33,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 34,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 35,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 36,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 37,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 38,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 39,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 12,
      discountPrice: 16.99 - (12 / 100) * 16.99,
      quantity: 10,
      id: 40,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 13,
      discountPrice: 14.99 - (13 / 100) * 14.99,
      quantity: 10,
      id: 41,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 14,
      discountPrice: 9.99 - (14 / 100) * 9.99,
      quantity: 10,
      id: 42,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 12.99 - (20 / 100) * 12.99,
      quantity: 10,
      id: 43,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 44,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 45,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 21,
      discountPrice: 12.99 - (21 / 100) * 12.99,
      quantity: 10,
      id: 46,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 47,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 48,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 16.99 - (22 / 100) * 16.99,
      quantity: 10,
      id: 49,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 14.99 - (22 / 100) * 14.99,
      quantity: 10,
      id: 50,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 23,
      discountPrice: 9.99 - (23 / 100) * 9.99,
      quantity: 10,
      id: 51,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 52,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 53,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 54,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 55,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 56,
    },
    {
      img: featurePizza,
      alt: "Pizza",
      name: "Truffle alfredo sauce",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 15.99,
      button: "Add to Cart",
      discount: 24,
      discountPrice: 19.99 - (24 / 100) * 19.99,
      quantity: 10,
      id: 57,
    },
    {
      img: featureSweet,
      alt: "cheese",
      name: "chesse cupcakes",
      desc: "Belgian chocolate cream cheese cupcakes covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 58,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 4,
      discountPrice: 19.99 - (4 / 100) * 19.99,
      quantity: 10,
      id: 59,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 7,
      discountPrice: 16.99 - (7 / 100) * 16.99,
      quantity: 10,
      id: 60,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 14.99 - (10 / 100) * 14.99,
      quantity: 10,
      id: 61,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 62,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 63,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 64,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 65,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 12.99 - (10 / 100) * 12.99,
      quantity: 10,
      id: 66,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 10,
      discountPrice: 9.99 - (10 / 100) * 9.99,
      quantity: 10,
      id: 67,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 68,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 12,
      discountPrice: 16.99 - (12 / 100) * 16.99,
      quantity: 10,
      id: 69,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 13,
      discountPrice: 14.99 - (13 / 100) * 14.99,
      quantity: 10,
      id: 70,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 14,
      discountPrice: 9.99 - (14 / 100) * 9.99,
      quantity: 10,
      id: 71,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 12.99 - (20 / 100) * 12.99,
      quantity: 10,
      id: 72,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 73,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 74,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 21,
      discountPrice: 12.99 - (21 / 100) * 12.99,
      quantity: 10,
      id: 75,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 9.99 - (22 / 100) * 9.99,
      quantity: 10,
      id: 76,
    },
    {
      img: product1,
      alt: "Pizza",
      name: "Supreme Pizza",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 19.99,
      button: "Add to Cart",
      discount: 11,
      discountPrice: 19.99 - (11 / 100) * 19.99,
      quantity: 10,
      id: 77,
    },
    {
      img: product2,
      alt: "Pizza",
      name: "Hawaiian Paradise",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 16.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 16.99 - (22 / 100) * 16.99,
      quantity: 10,
      id: 78,
    },
    {
      img: product3,
      alt: "Pizza",
      name: "Veggie Overload",
      desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 14.99,
      button: "Add to Cart",
      discount: 22,
      discountPrice: 14.99 - (22 / 100) * 14.99,
      quantity: 10,
      id: 79,
    },
    {
      img: sweet2,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 23,
      discountPrice: 9.99 - (23 / 100) * 9.99,
      quantity: 10,
      id: 80,
    },
    {
      img: sweet3,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 81,
    },
    {
      img: sweet1,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 82,
    },
    {
      img: sweet4,
      alt: "Donuts",
      name: "Doughlicious",
      desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 83,
    },
    {
      img: sweet5,
      alt: "Ice Cream",
      name: "Caramel Wonder",
      desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
      price: 12.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 12.99 - (25 / 100) * 12.99,
      quantity: 10,
      id: 84,
    },
    {
      img: sweet6,
      alt: "Brownie",
      name: "Brownie Bunch",
      desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
      price: 9.99,
      button: "Add to Cart",
      discount: 25,
      discountPrice: 9.99 - (25 / 100) * 9.99,
      quantity: 10,
      id: 85,
    },
    {
      img: featurePizza,
      alt: "Pizza",
      name: "Truffle alfredo sauce",
      desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
      price: 15.99,
      button: "Add to Cart",
      discount: 24,
      discountPrice: 19.99 - (24 / 100) * 19.99,
      quantity: 10,
      id: 86,
    },
    {
      img: featureSweet,
      alt: "cheese",
      name: "chesse cupcakes",
      desc: "Belgian chocolate cream cheese cupcakes covered in icing with sprinkles on top",
      price: 9.99,
      button: "Add to Cart",
      discount: 20,
      discountPrice: 9.99 - (20 / 100) * 9.99,
      quantity: 10,
      id: 87,
    },
  ],
  product: {},
};

const ProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PRODUCT":
      return {
        ...state,
        product: state.products.find(
          (product) => product.id === parseInt(action.id)
        ),
      };
    default:
      return state;
  }
};

export default ProductsReducer;
